import { useAuth, tLoginAction } from 'providers/Auth';

import { SignInWrapper } from './Base';

import { LoginValidation } from './Validation';
import { SignInForm } from './SignInForm';
import { ConfirmationCode } from './ConfirmationCode';
import { CodeSent } from './CodeSent';
import { LinkLoginWrapper } from './LinkLoginWrapper';

type ActionToComponent = {
  [key in Exclude<tLoginAction, null>]: () => JSX.Element | null;
};

const actionToComponent: ActionToComponent = {
  login: SignInForm,
  'validating-code': LoginValidation,
  'code-sent': CodeSent,
  'code-input': ConfirmationCode,
};

function SignIn() {
  const { loginAction } = useAuth();

  if (!loginAction) return null;

  const Component = actionToComponent[loginAction];

  if (!Component) return null;

  return (
    <SignInWrapper>
      <LinkLoginWrapper>
        <Component />
      </LinkLoginWrapper>
    </SignInWrapper>
  );
}

export default SignIn;
